import { useNavigate, useParams } from "react-router-dom";
import NotificationPlaydateWorkflow from "./NotificationPlaydateWorkflow";
import { useUser } from "contexts/UserContext";
import { useToastContext } from "contexts/ToastContext";

const NotificationPushPlaydateWorkflow: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const { user } = useUser();
    const navigate = useNavigate();
    const { triggerToastEvent } = useToastContext();

    const onDataChange = (success: boolean) => {
        if (success) {
            triggerToastEvent();
        }
        navigate("/home");
    }

    return <NotificationPlaydateWorkflow
        inviteID={id}
        user={user ?? undefined}
        onClose={() => navigate("/home")}
        onDataChange={onDataChange}
    />;
};

export default NotificationPushPlaydateWorkflow;